export enum GDMSStatus {
    DRAFT = 'draft',
    IN_WORKFLOW = 'inworkflow',
    INVALID = 'invalid',
    VALID = 'valid',
    RELEASED = 'released'
}
